import { Grid } from "@mui/material";
import React from "react";
import data from "@_fakeData/document-need";
import { getAssets } from "@unisearch/helpers";
import styles from "./document_need.module.scss";
import Image from "next/legacy/image";
import Link from "next/link";

const DocumentNeed = () => {
  return (
    <div className={styles.wrapper}>
      <div className="container">
        <div className={styles.heading_wrapper}>
          <h2>What Documents Do You Need?</h2>
          <p>
            Universities have their own requirement lists for what goes into an
            application package. There are some documents, though, that tend to
            be a universal component of any application! Take a look at our
            comprehensive breakdowns and tips for the most common university
            application documents.
          </p>
        </div>
        {data.map((item, index) => (
          <Grid
            key={index}
            container
            spacing={{ xs: 2, sm: 2, md: 3, xl: 4 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={6} order={index % 2 === 0 ? 0 : 1}>
              <div className={styles.img_wrapper}>
                <Image
                  layout="responsive"
                  width={570}
                  height={524}
                  blurDataURL={getAssets(
                    "assets/images/study/country_placeholder.webp"
                  )}
                  placeholder="blur"
                  src={
                    item.img ||
                    getAssets("assets/images/study/country_placeholder.webp")
                  }
                  alt={item.heading || ""}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <div className={styles.right}>
                <h3>{item.heading}</h3>
                <p>{item.text1}</p>

                {item?.slug && (
                  <Link
                    href={`/document/${item?.slug}`}
                    className={`${styles.btn} btn btn-outline btn-md w-max`}
                  >
                    Learn More
                  </Link>
                )}
              </div>
            </Grid>
          </Grid>
        ))}
      </div>
    </div>
  );
};

export default DocumentNeed;
